import { Card, Drawer, Table } from 'antd'
import React, { useRef } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { TableComp } from 'sz-react-utils-lite'
import { DisplayDate } from '../../../components/_utils/appUtils'
import { RowTable } from '../../article/articleView/RowTable'

const SubmissionErrorFullDetailsDrawer = props => {
  let { onClose, visible, data } = props
  let authorTable = useRef()

  const safeData = data || {}
  const rawBody = safeData.rawBody || {}
  const abstractData = rawBody.abstract || rawBody || {}

  const totalAuthors = abstractData.coAuthors ? abstractData.coAuthors.length + 1 : (abstractData.authorName ? 1 : 'N/A');

  let combinedAuthors = []

  if (abstractData.authorName) {
    combinedAuthors.push({
      key: 'main',
      name: abstractData.authorName,
      instituteAffiliated: abstractData.institution,
      designation: abstractData.designation,
      email: abstractData.email,
      phoneNo: abstractData.mobile,
      country: abstractData.country
    })
  }
  if (abstractData.coAuthors && Array.isArray(abstractData.coAuthors)) {
    abstractData.coAuthors.forEach((co, idx) => {
      combinedAuthors.push({
        key: `co-${idx}`,
        name: co.name,
        instituteAffiliated: co.affiliation,
        designation: co.designation,
        email: co.email,
        phoneNo: 'N/A',
        country: co.country
      })
    })
  }
  const authorData = rawBody.authors || abstractData.authors || combinedAuthors || []

  const AuthorColumns = [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name'
    },
    {
      title: 'Institute Affiliated',
      key: 'instituteAffiliated',
      dataIndex: 'instituteAffiliated'
    },
    {
      title: 'Designation',
      key: 'designation',
      dataIndex: 'designation'
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email'
    },
    {
      title: 'Phone Number',
      key: 'phoneNo',
      dataIndex: 'phoneNo'
    },
    {
      title: 'Country',
      key: 'country',
      dataIndex: 'country'
    }
  ]

  return (
    <React.Fragment>
      {visible ? (
        <Drawer
          visible={visible}
          width={'86%'}
          placement="right"
          onClose={onClose}
          title={'Failed Submission Details'}>
          <Card>
            <div className={'tableBox striped'}>
              <RowTable title={'Journal'} value={abstractData.journal || 'N/A'} />
              <RowTable title={'Issue Type'} value={abstractData.issueType || 'N/A'} />
              <RowTable title={'Country'} value={abstractData.country || 'N/A'} />
              <RowTable
                title={'Manuscript Title'}
                value={abstractData.manuScriptTitle || abstractData.titleOfAbstract || 'N/A'}
              />
              <RowTable title={'Article Type'} value={abstractData.articleType || 'N/A'} />
              <RowTable
                title={'Area of Research'}
                value={abstractData.areaOfResearch || abstractData.researchArea || 'N/A'}
              />
              <RowTable
                title={'Year of Research'}
                value={abstractData.yearOfResearch || 'N/A'}
              />
              <RowTable
                title={'Duration of Research'}
                value={abstractData.durationOfResearch || 'N/A'}
              />
              <RowTable
                title={'Abstract'}
                value={
                  <div>
                    {abstractData.abstract ? ReactHtmlParser(abstractData.abstract) : 'N/A'}
                  </div>
                }
              />
              <RowTable
                title={'Subject of Message'}
                value={abstractData.message ? ReactHtmlParser(abstractData.message) : 'N/A'}
              />
              <RowTable
                title={'Total Number of Author'}
                value={abstractData.noOfAuthor || totalAuthors}
              />
              <RowTable
                title={'Corresponding Author'}
                value={safeData.correspondingAuthor || abstractData.correspondingAuthor || abstractData.authorName || 'N/A'}
              />
              <RowTable
                title={'Corresponding Author Affiliation'}
                value={abstractData.correspondingAuthorAffiliation || abstractData.institution || 'N/A'}
              />
              <RowTable
                title={'Corresponding Authors Email'}
                value={safeData.correspondingAuthorsEmail || abstractData.correspondingAuthorsEmail || abstractData.email || 'N/A'}
              />
              <RowTable
                title={'Corresponding Author Contact'}
                value={abstractData.correspondingAuthorContact || abstractData.mobile || 'N/A'}
              />
              <RowTable
                title={'Corresponding Author Address'}
                value={abstractData.correspondingAuthorAddress || abstractData.country || 'N/A'}
              />
            </div>
            <br />
            <h3>Authors</h3>
            <TableComp
              columns={AuthorColumns}
              ref={authorTable}
              dataSource={authorData}
              size={'small'}
              pagination={false}
            />
          </Card>
        </Drawer>
      ) : null}
    </React.Fragment>
  )
}

export default SubmissionErrorFullDetailsDrawer